import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Link,
  makeStyles,
} from "@material-ui/core";
import { UpdatedValue } from "@ofqual/portal-activity-feed/activityfeed/UpdatedValue";
import { ActivityDialogProps, ChangeActivityBody } from "../types";
import { fieldLabels } from "../Sections/fieldLabels";
import { isIsoDateString } from "@ofqual/portal-core/core/utils/dateUtils";

const useStyles = makeStyles(() => ({
  changeDetails: {
    padding: 15,
  },
  actions: {
    padding: 15,
  },
}));

export const UpdatedDialog: React.FC<ActivityDialogProps> = ({
  activity,
  onClose,
}) => {
  const classes = useStyles();

  const body: ChangeActivityBody = JSON.parse(activity.activityMetaData);

  //dates right and thats all we need brn
  const convertUtcStringToLocal = function (dateStr: any) {
    const parsedDate = new Date(dateStr);
    return parsedDate.toLocaleDateString("pt-PT"); // DD/MM/YYYY
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="updated-dialog"
    >
      <DialogTitle data-test="activity-title">
        {activity.activityTitle}
      </DialogTitle>
      <Divider />
      <DialogContent>
        {body.changes.map((change) => (
          <div key={change.field}>
            <h3 data-test="activity-field-title">
              {fieldLabels[change.field]}
            </h3>
            <div
              className={classes.changeDetails}
              data-test="activity-field-body"
            >
              <Grid container spacing={3}>
                <Grid item>
                  <b>Old value:</b>
                </Grid>
                <Grid item md={10} data-test="old-value">
                  <UpdatedValue
                    value={
                      isIsoDateString(change.oldValue)
                        ? convertUtcStringToLocal(change.oldValue)
                        : change.oldValue
                    }
                    fieldLabels={fieldLabels}
                  />
                </Grid>
                <Grid item>
                  <b>New value:</b>
                </Grid>
                <Grid item md={10} data-test="new-value">
                  <UpdatedValue
                    value={
                      isIsoDateString(change.newValue)
                        ? convertUtcStringToLocal(change.newValue)
                        : change.newValue
                    }
                    fieldLabels={fieldLabels}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        ))}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Link
          component="button"
          onClick={onClose}
          data-test="close-change-button"
        >
          Close
        </Link>
      </DialogActions>
    </Dialog>
  );
};
// function convertUtcStringToLocal(newValue: string | null): any {
//   throw new Error("Function not implemented.");
// }
